import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TCustomerStatusHistoryDataTableData = {
  primaryKey: string | number,
  operationDate: string,
  customerId: string,
  oldStatus: string,
  dateOldStatus: string,
  newStatus: string,
  effectiveDate: string,
  reason: string,
  user: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TCustomerStatusHistoryDataTableData>();

export function getCustomerStatusHistoryDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('operationDate', {
      id: 'operationDate',
      header: 'Date Oper.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('customerId', {
      id: 'customerId',
      header: 'ID Client',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('oldStatus', {
      id: 'oldStatus',
      header: 'Anc. Statut',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dateOldStatus', {
      id: 'dateOldStatus',
      header: 'Date Anc. Statut',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('newStatus', {
      id: 'newStatus',
      header: 'Nouv. Statut',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('effectiveDate', {
      id: 'effectiveDate',
      header: 'Date Effe.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('reason', {
      id: 'reason',
      header: 'Motif',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('user', {
      id: 'user',
      header: 'Utilisateur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
  ];
}
